import React from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import { Certification } from 'app/redux/models/Certification.model';
import './CertificationBadges.scss';

interface CertificationBadgesProps {
    certifications: Certification[];
}

export function CertificationBadges({ certifications }: CertificationBadgesProps) {

    if(certifications.length === 0) {
        return null;
    }

    const sortedCertifications = [...certifications].sort((first, second) => first.name.localeCompare(second.name));

    return (
        <div className="certification-badges" data-testid="certification-badges">
            {sortedCertifications.map((certification) => <Tooltip title={certification.name} key={certification.id}>
                {certification.imageUrl
                    ? <img className="certification-badge" src={certification.imageUrl} alt={certification.name} referrerPolicy="no-referrer" />
                    : <Icon className="certification-badge certification-badge-icon" aria-label={certification.name}>school</Icon>
                }
            </Tooltip>)}
        </div>
    );
}

export default CertificationBadges;
